import { Typography } from '@/components/atoms/Typography/Typography.styled';
import { medias } from '@/utils/sizes';
import { generateClampFromMinMax } from '@/utils/styling';
import styled, { css } from 'styled-components';

export const RowsContainer = styled.div`
  .closing-text {
    margin-top: var(--spacing-component-inner);
  }
`;
export const InnerRow = styled.div.withConfig({
  shouldForwardProp: (prop) => !['isOnlyText', 'openedInitial'].includes(prop),
})<{
  isOnlyText: boolean;
  openedInitial?: boolean;
}>`
  display: grid;
  grid-template-columns: 30% 50% 20%;
  padding: var(--spacing-component-inner-sm) 0;
  /* transition: height var(--tr-base) ease-in-out; */
  position: relative;

  &.first-row {
    border-top: 1px solid var(--c-border);
  }

  ${({ isOnlyText }) =>
    isOnlyText
      ? css`
          pointer-events: none;

          &.first-row {
            padding-bottom: var(--spacing-component-inner-sm);
          }
        `
      : css`
          cursor: pointer;
        `}

  &.second-row {
    height: ${(props) => (props.openedInitial ? 'auto' : 0)};
    overflow: hidden;
    /* transition: height var(--tr-base) ease-in-out; */
    padding: 0;

    &:after {
      content: '';
      display: block;
      width: 100%;
      height: var(--spacing-component-inner-sm);
    }
  }

  p,
  img {
    transition: opacity var(--tr-base) 0.15s ease-in-out;
  }

  .description {
    padding: var(--spacing-component-inner-sm) 0;
  }

  &[data-is-opened='false'] {
    height: 0 !important;

    p,
    img {
      opacity: 0;
    }
  }

  img {
    padding-bottom: var(--spacing-component-inner-sm);
  }

  .icon-plus {
    position: absolute;
    right: 0;
    top: 50%;
    opacity: 1;
    transform: translateY(-50%);
    transition: opacity var(--tr-base);
    margin-right: 10px;

    ${medias.min.desktop} {
      height: 30px;
      width: 30px;
    }

    ${medias.max.tablet} {
      opacity: 1;
      margin-right: 0px;
    }
  }

  ${medias.max.mobile} {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 28px;

    &.second-row {
      display: flex;
      flex-direction: column;
      width: 85%;
      margin-left: auto;

      div:has(img) {
        aspect-ratio: 1 !important;
        width: 90% !important;
        margin-top: var(--spacing-component-inner);
      }

      img {
        padding-bottom: var(--spacing-component-inner-sm);
      }

      .description {
        padding: var(--spacing-component-inner-sm) 0;
      }
    }
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-component-inner);

  ${Typography} {
    max-width: ${generateClampFromMinMax(400, 600)};
  }

  ${medias.max.mobile} {
    padding-right: 15px;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  transition: background-color var(--tr-base) ease-in-out;

  &:has(.second-row):not(:has([data-is-opened='true'])):hover {
    background-color: rgb(24, 24, 23);
  }
`;
